import { useState, useRef } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import '../../../styles/public-portal.css';
import NewsHeader from './NewsHeader';
import NewsFooter from './NewsFooter';
import NewsSidebar from './NewsSidebar';
import PublicMotion from './PublicMotion';

const NewsLayout = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const rootRef = useRef(null);
  const { pathname } = useLocation();
  const isHome = pathname === '/' || pathname === '/news';

  return (
    <div ref={rootRef} className="public-portal min-h-screen bg-white flex flex-col">
      <PublicMotion rootRef={rootRef} routeKey={pathname} />
      <NewsHeader
        onMenuToggle={() => setMobileMenuOpen(v => !v)}
        menuOpen={mobileMenuOpen}
        onMenuClose={() => setMobileMenuOpen(false)}
      />

      <main className={`portal-main flex-1 w-full max-w-7xl mx-auto px-3 sm:px-4 lg:px-6 py-4 ${isHome ? 'portal-home' : ''}`}>
        <div className="flex flex-col lg:flex-row gap-6">
          <div className="flex-1 min-w-0">
            <Outlet />
          </div>
          {!isHome && <aside className="w-full lg:w-72 xl:w-80 flex-shrink-0">
            <NewsSidebar />
          </aside>}
        </div>
      </main>

      <NewsFooter />
    </div>
  );
};

export default NewsLayout;
